<template>
  <div class="room remote-history" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command-container">
      <div class="table-command">
        <span class="table-command-item-key dh-right">{{ bridgeName }}</span>
        <div class="table-command-item-station">
          <span class="table-command-item-key">设备组:</span>
          <el-select v-model="selectedStation" placeholder="请选择设备组" class="station-select">
            <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName" :value="item.stationId"></el-option>
          </el-select>
        </div>
        <!--TODO: 仅在有风量和风速同时出现的设备组显示 -->
        <div class="table-command-item-switch" v-if="false">
          <span class="table-command-item-key">隐藏风速</span>
          <el-switch v-model="useVolumeNotSpeed"></el-switch>
        </div>
        <div class="table-command-item-switch">
          <span class="table-command-item-key">导出数据</span>
          <el-switch v-model="exportMode"></el-switch>
        </div>
        <div class="table-command-item-approve" v-if="exportMode">
          <span class="table-command-item-key">高频时段:</span>
          <el-select v-model="selectedApprove" placeholder="选择高频提交批准时段" clearable class="approve-select">
            <el-option v-for="item in approveList" :key="item.approveId" :label="item.comment" :value="item.approveId"></el-option>
          </el-select>
        </div>
        <div class="table-command-item-date" v-if="exportMode">
          <span class="table-command-item-key">起始时间</span>
          <el-date-picker
            class="date-time"
            v-model="exportStartDate"
            type="datetime"
            placeholder="选择日期时间"
            :editable="false"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
          ></el-date-picker>
        </div>
        <div class="table-command-item-date" v-if="exportMode">
          <span class="table-command-item-key">截止时间</span>
          <el-date-picker
            class="date-time"
            v-model="exportEndDate"
            type="datetime"
            placeholder="选择日期时间"
            :editable="false"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
          ></el-date-picker>
        </div>
      </div>

      <div></div>
    </div>

    <el-table :data="rowList_current" style="width: 100%" :max-height="tableMaxHeight" :cell-class-name="tableCellClassName">
      <el-table-column align="center" label="设备名" prop="rawDeviceName"></el-table-column>

      <el-table-column align="center" label="湿度" width="100">
        <template slot-scope="scope">
          <el-tag class="percentage-tag" effect="dark" :type="scope.row.humidityClass">{{ scope.row.humidityValue }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="湿度时间" v-if="(deviceTypeExistDict['温度'] || true) && !exportMode">
        <template slot-scope="scope">
          {{ scope.row.humidityDate }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="湿度导出" v-if="exportMode">
        <template slot-scope="scope">
          <el-button class="exportButton" effect="dark" size="small" type="" @click="exportHighFrequencyData(scope.row.humidityDeviceId)"
            >导出数据</el-button
          >
        </template>
      </el-table-column>

      <template v-for="typeName in Object.keys(deviceTypeInfoDict)">
        <el-table-column align="center" :label="typeName" width="100" v-if="deviceTypeExistDict[typeName]" :key="typeName + 'value'">
          <template slot-scope="scope">
            <el-tag class="percentage-tag" effect="dark" :type="scope.row[deviceTypeInfoDict[typeName] + 'Class']">{{
              scope.row[deviceTypeInfoDict[typeName] + "Value"]
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="typeName + '时间'"
          :prop="deviceTypeInfoDict[typeName] + 'Date'"
          :key="typeName + 'date'"
          v-if="deviceTypeExistDict[typeName] && !exportMode"
        ></el-table-column>
        <el-table-column align="center" :label="typeName + '导出'" v-if="deviceTypeExistDict[typeName] && exportMode" :key="typeName + 'export'">
          <template slot-scope="scope">
            <el-button
              class="exportButton"
              effect="dark"
              size="small"
              type=""
              v-if="scope.row[deviceTypeInfoDict[typeName] + 'ExportAvailable']"
              @click="exportHighFrequencyData(scope.row[deviceTypeInfoDict[typeName] + 'DeviceId'])"
              >导出数据</el-button
            >
            <el-tag class="percentage-tag" effect="dark" type="info" v-if="!scope.row[deviceTypeInfoDict[typeName] + 'ExportAvailable']">NA</el-tag>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      :current-page.sync="currentPage"
      ref="page"
    ></el-pagination>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { dateTimeToString, newtonsoftJsonToDate } from "../tools/GeneralTool";

export default {
  name: "SimpleCurrentData",
  data() {
    return {
      timer: null,
      tableData: [],
      loading: false,
      shownewUser: false,
      checkUserId: "",
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      bridgeId: "",
      bridgeName: "",
      bridgeHasErrorRecord: false,
      bridgeTranslateDict: {},
      deviceTranslateDict: {},
      deviceNameReplaceList: ["状态", "(枚举)"],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
      firstIndex: 0,
      lastIndex: 0,
      historyScenarioCurrentGroupNameList: [],

      dataTypeOptions: [],

      routeBridgeId: "",
      deviceIdDeviceNameDict: {},
      stationList: [],
      stationListFull: [],
      selectedStation: "",
      selectedDataType: "ALL",

      rowList_all: [],
      rowList_current: [],

      dataList_all: [],

      approveList: [],
      selectedApprove: "",

      useVolumeNotSpeed: true,
      exportMode: false,
      exportStartDate: "",
      exportEndDate: "",

      deviceTypeExistDict: {},
      deviceTypeUnitDict: {},
      deviceTypeInfoDict: {
        温度: "temperature",
        压差: "pressureDiff",
        压力: "pressure",
        风量: "volume",
        进气风量: "inputVolume",
        排气风量: "outputVolume",
        风速: "speed",
        进气风速: "inputSpeed",
        排气风速: "outputSpeed",
        流量: "flow",
        流量1: "flowA",
        流量2: "flowB",
      },
    };
  },
  computed: {
    tableSpanRowIndexDict() {
      let clientMissionIdRowIndexListDict = {};
      for (let i = 0; i < this.tableData.length; i++) {
        const mission = this.tableData[i];
        if (clientMissionIdRowIndexListDict[mission.clientMissionId] === undefined) {
          clientMissionIdRowIndexListDict[mission.clientMissionId] = [i];
        } else {
          clientMissionIdRowIndexListDict[mission.clientMissionId].push(i);
        }
      }

      let result = {};
      for (let clientMissionId in clientMissionIdRowIndexListDict) {
        let rowList = clientMissionIdRowIndexListDict[clientMissionId];
        result[Math.min.apply(null, rowList)] = rowList.length;
      }

      return result;
    },
    ...mapGetters({
      isAdmin: "getIsAdmin",
      bridgeList: "getBridgeList",
    }),
  },
  mounted() {
    this.loading = true;

    this.timer = setInterval(() => {
      this.getDataList();
    }, this.REFRESH_SECOND);

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
    };

    this.initializeStationAndGetData();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };
      });
    },
    $route(route) {
      if (this.$route.query.bridgeId !== this.routeBridgeId) {
        this.selectedStation = "";
        this.initializeStationAndGetData();
      }
    },
    selectedDataType() {
      this.dataTypeOnChange();
    },
    selectedStation() {
      this.loading = true;
      this.currentPage = 1;
      this.selectedApprove = "";
      this.getDataList();
    },
    useVolumeNotSpeed() {
      this.getDataList();
    },
    selectedApprove() {
      for (let approveItem of this.approveList) {
        if (approveItem.approveId === this.selectedApprove) {
          this.exportStartDate = approveItem.startDate;
          this.exportEndDate = approveItem.endDate;
        }
      }
    },
  },
  methods: {
    initializeStationAndGetData() {
      this.loading = true;
      this.routeBridgeId = this.$route.query.bridgeId;

      let routeBridgeIdConfirmed = false;
      this.bridgeList.forEach((bridge) => {
        if (bridge.id === this.routeBridgeId) {
          routeBridgeIdConfirmed = true;
          //break
          return false;
        }
      });

      if (!routeBridgeIdConfirmed) {
        this.$alert("无效的桥梁编号", {
          confirmButtonText: "确定",
          showClose: true,
          type: "error",
          callback: (action) => {
            // console.log('stop');
            // this.resultObjectList = [];
          },
        });

        return;
      }

      this.stationList = [];
      this.stationListFull = [];
      this.$http.get("/bridge/bridgeinfo?bridgeId=" + this.routeBridgeId).then((res) => {
        this.bridgeHasErrorRecord = res.data.recordDataErrorReporForWebpage;
        res.data.stationList.forEach((stationItem) => {
          if (stationItem.isHighFrequencyDeviceStation) {
            this.stationList.push({
              stationId: stationItem.stationId,
              stationName: stationItem.stationName,
            });

            this.stationListFull.push({
              stationId: stationItem.stationId,
              stationName: stationItem.stationName,
            });
          }
        });

        let firstStationIsAll = false;
        if (this.stationList.length > 1) {
          firstStationIsAll = true;
          this.stationList.splice(0, 0, { stationId: "ALL", stationName: "全部" });
        }

        this.$nextTick(() => {
          if (this.stationList.length > 0) {
            if (firstStationIsAll) {
              this.selectedStation = this.stationList[1].stationId;
            } else {
              this.selectedStation = this.stationList[0].stationId;
            }
          }

          this.bridgeName = res.data.bridgeName;
          this.currentPage = 1;
          this.getDataList();
        });
      });
    },
    hrefErrorRecord() {
      let url = this.$route.path;
      let firstSlash = url.indexOf("/");
      if (firstSlash < 0) {
        return;
      }
      let secondSlash = url.indexOf("/", firstSlash + 1);
      if (secondSlash < 0) {
        return;
      }

      let result = url.slice(0, secondSlash);
      result = result + "/errorRecord?bridgeId=" + this.routeBridgeId + "&stationId=" + this.selectedStation;
      this.$router.push(result);
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex !== 0 && columnIndex % 2 === 0) {
        return "table-row-spliter";
      } else {
        return "";
      }
    },
    dataTypeOnChange() {
      this.filterDataByDataType();
      this.currentChange(1);
    },
    filterDataByDataType() {
      this.rowList_all = this.assembleDataRow(this.dataList_all);

      this.totalCount = this.rowList_all.length;
    },
    refreshData() {
      this.loading = true;
      this.getDataList();
    },
    currentChange(index) {
      this.loading = true;
      this.currentPage = index;

      let result = [];
      let pageStart = (this.currentPage - 1) * this.pageSize;
      for (let i = 0; i < this.pageSize; i++) {
        let actualIndex = pageStart + i;
        if (actualIndex >= this.rowList_all.length) {
          break;
        }

        result.push(this.rowList_all[actualIndex]);
      }

      this.rowList_current = result;

      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    getDataCount() {
      this.$http.get("/user/GetUserLoginRecordCount?userId=" + this.routeUserId).then((res) => {
        this.totalCount = res.data.count;
      });
    },
    getDataList() {
      this.loading = true;

      if (!this.selectedStation || this.selectedStation === "") {
        this.dataList_all = [];
        this.deviceTypeExistDict = { 湿度: true };
        this.approveList = [];
        this.selectedApprove = "";

        this.filterDataByDataType();
        this.currentChange(this.currentPage);
        setTimeout(() => {
          this.loading = false;
        }, 500);

        return;
      }

      let targetStationList = [];
      let targetStationReadyDict = {};
      if (this.selectedStation === "ALL") {
        for (let stationItem of this.stationListFull) {
          targetStationList.push(stationItem.stationId);
          targetStationReadyDict[stationItem.stationId] = false;
        }
      } else {
        targetStationList = [this.selectedStation];
        targetStationReadyDict[this.selectedStation] = false;
      }

      this.deviceIdDeviceNameDict = {};
      this.dataList_all = [];
      this.deviceTypeExistDict = { 湿度: true };
      this.deviceTypeUnitDict = { 湿度: "%" };
      for (let targetStationItem of targetStationList) {
        let metaQuery = this.$http.get("/bridge/stationInfo?stationId=" + targetStationItem);
        let dataQuery = this.$http.get("/deviceData/station?stationId=" + targetStationItem);
        let approveQuery = this.$http.get(
          "/highFrequencyDevice/GetHighFrequencyDeviceApproveWorkList?stationId=" + targetStationItem + "&start=0&limit=100"
        );
        this.$http.all([metaQuery, dataQuery, approveQuery]).then(
          this.$http.spread((metaRes, dataRes, approveRes) => {
            let deviceIdUnitDict = {};
            metaRes.data.deviceList.forEach((deviceItem) => {
              let deviceName = deviceItem.deviceName;
              if (deviceItem.highFrequencyDeviceName) {
                deviceName = deviceItem.highFrequencyDeviceName;
              }
              this.deviceIdDeviceNameDict[deviceItem.deviceId] = deviceName.replace("(" + deviceItem.unit + ")", "");
              deviceIdUnitDict[deviceItem.deviceId] = deviceItem.unit;
            });

            let deviceNameDataDict = {};
            for (let dataId in dataRes.data) {
              let dataItem = dataRes.data[dataId];
              if (this.deviceIdDeviceNameDict[dataItem.deviceId] && deviceIdUnitDict[dataItem.deviceId]) {
                let deviceName = this.deviceIdDeviceNameDict[dataItem.deviceId];
                deviceNameDataDict[deviceName] = dataItem;
              }
            }

            for (let dataId in dataRes.data) {
              let humidityDataItem = dataRes.data[dataId];
              let deviceName;
              if (this.deviceIdDeviceNameDict[humidityDataItem.deviceId]) {
                deviceName = this.deviceIdDeviceNameDict[humidityDataItem.deviceId];
              }
              if (!deviceName) {
                continue;
              }
              if (deviceName.indexOf("湿度") < 0) {
                continue;
              }

              let rawDeviceName = deviceName.replace("湿度", "");
              let errorClass = this.getErrorClassByErrorLevel(humidityDataItem.errorLevel);
              let dataDate = dateTimeToString(newtonsoftJsonToDate(humidityDataItem.dataDate), "YY年MM月dd日 HH:mm");
              let value = humidityDataItem.value;
              let humidityDeviceId = humidityDataItem.deviceId;
              if (humidityDataItem.errorLevel.toLowerCase() === "warning") {
                value = "--";
                dataDate = "--";
              } else {
                value = value.toFixed(2);
              }
              let dataItem = {
                rawDeviceName: rawDeviceName,
                humidityValue: value,
                humidityDate: dataDate,
                humidityClass: errorClass,
                humidityDeviceId: humidityDeviceId,
                humidityExportAvailable: true,
              };

              let volumeExistTypeNameDict = {};
              for (let typeName in this.deviceTypeInfoDict) {
                // 风量 > 风速. 开关控制 有风量则不显示风速
                if (this.useVolumeNotSpeed) {
                  if (typeName.indexOf("风速") >= 0 || typeName.indexOf("流速") >= 0) {
                    let volumeTypeName = typeName.replace("风速", "风量").replace("流速", "流量");
                    if (volumeExistTypeNameDict[volumeTypeName]) {
                      continue;
                    }
                  }
                }

                let typeKey = this.deviceTypeInfoDict[typeName];
                let typeDeviceName = deviceName.replace("湿度", typeName);
                if (deviceNameDataDict[typeDeviceName]) {
                  let targetDataItem = deviceNameDataDict[typeDeviceName];
                  let targetErrorClass = this.getErrorClassByErrorLevel(targetDataItem.errorLevel);
                  let targetValue = targetDataItem.value;
                  let targetDeviceId = targetDataItem.deviceId;
                  let targetDataDate = dateTimeToString(newtonsoftJsonToDate(targetDataItem.dataDate), "YY年MM月dd日 HH:mm");
                  if (targetDataItem.errorLevel.toLowerCase() === "warning") {
                    targetValue = "--";
                    targetDataDate = "--";
                  } else {
                    if (typeKey === "pressure") {
                      //北盘江高频试验: 压力保留3位
                      targetValue = targetValue.toFixed(3);
                    } else {
                      targetValue = targetValue.toFixed(2);
                    }
                  }

                  dataItem[typeKey + "Value"] = targetValue;
                  dataItem[typeKey + "Date"] = targetDataDate;
                  dataItem[typeKey + "Class"] = targetErrorClass;
                  dataItem[typeKey + "DeviceId"] = targetDeviceId;
                  dataItem[typeKey + "ExportAvailable"] = true;

                  if (!this.deviceTypeExistDict[typeName]) {
                    this.deviceTypeExistDict[typeName] = true;
                  }
                  if (!this.deviceTypeUnitDict[typeName] && deviceIdUnitDict[targetDataItem.deviceId]) {
                    this.deviceTypeUnitDict[typeName] = deviceIdUnitDict[targetDataItem.deviceId];
                  }
                  if (typeName.indexOf("风量") >= 0 || typeName.indexOf("流量") >= 0) {
                    volumeExistTypeNameDict[typeName] = true;
                  }
                }
              }

              this.dataList_all.push(dataItem);
            }

            for (let dataItem of this.dataList_all) {
              for (let typeName in this.deviceTypeInfoDict) {
                let typeKey = this.deviceTypeInfoDict[typeName];

                if (!dataItem[typeKey + "Date"]) {
                  dataItem[typeKey + "Value"] = "NA";
                  dataItem[typeKey + "Date"] = "NA";
                  dataItem[typeKey + "Class"] = "info";
                  dataItem[typeKey + "ExportAvailable"] = false;
                }
              }
            }

            targetStationReadyDict[targetStationItem] = true;
            let allStationReady = true;
            for (let stationId in targetStationReadyDict) {
              if (!targetStationReadyDict[stationId]) {
                allStationReady = false;
                break;
              }
            }

            if (allStationReady) {
              this.approveList = [];
              for (let approveItem of approveRes.data) {
                let startDate = newtonsoftJsonToDate(approveItem.approveStartDate);
                let endDate = newtonsoftJsonToDate(approveItem.ApproveEndDate);
                // if (endDate > new Date()) {
                //   continue;
                // }

                endDate.setMinutes(endDate.getMinutes() + 1);
                approveItem.startDate = dateTimeToString(startDate, "yyyy-MM-dd HH:mm");
                approveItem.endDate = dateTimeToString(endDate, "yyyy-MM-dd HH:mm");

                if (!approveItem.comment || approveItem.comment === "") {
                  approveItem.comment = "未命名";
                }

                this.approveList.push(approveItem);
              }

              this.filterDataByDataType();
              this.currentChange(this.currentPage);
              setTimeout(() => {
                this.loading = false;
              }, 500);
            }
          })
        );
      }
    },
    getErrorClassByErrorLevel(errorLevel) {
      if (errorLevel.toLowerCase() === "normal") {
        return "primary";
      } else if (errorLevel.toLowerCase() === "warning") {
        return "warning";
      } else if (errorLevel.toLowerCase() === "error") {
        return "danger";
      } else {
        return "info";
      }
    },
    exportHighFrequencyData(deviceId) {
      if (!this.exportStartDate || this.exportStartDate === "") {
        this.$message.error("请输入导出起始时间");
        return;
      }
      if (!this.exportEndDate || this.exportEndDate === "") {
        this.$message.error("请输入导出截止时间");
        return;
      }

      let $url = "/excel/HighFrequencyDevice?deviceId=" + deviceId + "&dataStartDate=" + this.exportStartDate + "&dataEndDate=" + this.exportEndDate;
      console.log("export high frequency data: " + $url);

      window.open($url);
    },
    assembleDataRow(dataList) {
      return dataList;
    },
    translateBridgeName(bridgeId) {
      for (let bridge of this.bridgeList) {
        if (bridge.id === bridgeId) {
          return bridge.name;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.remote-history {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;
  .table-command-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .table-command {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-start;
  }
  .table-command-right {
    display: flex;
    margin-right: 20px;
  }
  .table-command-item-key {
    margin-right: 10px;
    margin-left: 20px;
    margin-top: 10px;
  }

  .table-command-item-station {
    width: 280px;
  }

  .table-command-item-switch {
    width: 155px;
  }

  .table-command-item-approve {
    width: 240px;
  }

  .table-command-item-date {
    width: 220px;
  }

  .pagination {
    position: absolute;
    bottom: 0;
  }
}
.status-tag {
  cursor: pointer;
}
.table-button {
  margin-bottom: 10px;
  margin-left: 10px;
}

.dialog-form-input {
  width: 80%;
}

.error-level-tag {
  min-width: 75px;
}

.station-select {
  width: 180px;
}

.approve-select {
  width: 200px;
}

.date-time {
  width: 180px;
}

::v-deep .table-row-spliter {
  border-right: 1px solid #ebeff0;
}

::v-deep .el-pagination {
  text-align: center;
}
</style>
